import React from 'react';

import { ColumnHeaderSortable } from '../../../DataTable/index.jsx';
import PercentageFigure from '../../../PercentageFigure/index.jsx';

import Column from './base.jsx';

const columnOptions = {
  id: 'col-pc-7d',
  title: 'Change Percent (7 Days)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return '7d';
  }

  get overlayText() {
    return 'Change % in last 7 days';
  }

  get rightAlign() {
    return true;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td className="text-right">
        {this.props.row.priceChange7d && <PercentageFigure amount={this.props.row.priceChange7d} />}
      </td>
    );
  }
}


class PriceChange7d extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.priceChange7d < b.priceChange7d) {
      return -1;
    }
    if (a.priceChange7d > b.priceChange7d) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.priceChange7d < b.priceChange7d) {
      return 1;
    }
    if (a.priceChange7d > b.priceChange7d) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default PriceChange7d;

